import * as ActionTypes from '~/actions/ActionTypes'

export const startProjectLoading = () => async dispatch => {
  await dispatch({ type: ActionTypes.PROJECTS_START_PROJECT_LOAING })
}
